"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
function addPushNotificationDevice(deviceToken, deviceOS, mobileAppID, backendSystemID) {
    var service = new service_1.EVAService("AddPushNotificationDevice");
    // Build the request data
    // The base class will add things like SessionID so keep typescript
    // happy we're using an 'any' type object here
    //
    var requestData = {
        DeviceToken: deviceToken,
        DeviceOS: deviceOS,
        MobileAppID: mobileAppID,
        BackendSystemID: backendSystemID
    };
    // Perform the call and capture the resulting promise
    //
    return service.call(requestData);
}
exports.addPushNotificationDevice = addPushNotificationDevice;
function removePushNotificationDevice(deviceToken, backendSystemID) {
    var service = new service_1.EVAService("RemovePushNotificationDevice");
    // Build the request data
    // The base class will add things like SessionID so keep typescript
    // happy we're using an 'any' type object here
    //
    var requestData = {
        DeviceToken: deviceToken,
        BackendSystemID: backendSystemID
    };
    // Perform the call and capture the resulting promise
    //
    return service.call(requestData);
}
exports.removePushNotificationDevice = removePushNotificationDevice;
